import { VApp } from 'vuetify/lib/components/VApp';

var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c(VApp,[_c('div',{staticClass:"showtracker",attrs:{"id":"showtracker"}},[(!_vm.IsMobile())?_c('Sidebar'):_vm._e(),_c('div',{staticClass:"page",attrs:{"id":"page"}},[_c('Header'),_c('router-view'),(_vm.IsMobile())?_c('Bottombar'):_vm._e()],1)],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }